export default `
  mutation deleteOrgMember($id: String!, $orgId: String!, $userId: String) {
    deleteOrgMember(id: $id, orgId: $orgId, userId: $userId) {
      id
      orgId
      userId
    }
  }
`
